export const COMMODITIES_TYPE: {
  [type: string]: {
    id: number;
    description: string;
  };
} = {
  ENERGY: {
    id: 1,
    description: 'ENERGY',
  },
  METALS: {
    id: 2,
    description: 'METALS',
  },
  FUT_INDEX: {
    id: 3,
    description: 'FUT_INDEX',
  },
  FUT_CURRENCY: {
    id: 4,
    description: 'FUT_CURRENCY', /// Hay que validarlo
  },
  ETHANOL: {
    id: 5,
    description: 'ETHANOL',
  },
  COMDTYETFS: {
    id: 6,
    description: 'COMDTYETFS',
  },
  AGRIC: {
    id: 7,
    description: 'AGRIC',
  },
  LIVE_STOCK: {
    id: 8,
    description: 'LIVE_STOCK', /// Hay que validarlo
  },
  TREASURY: {
    id: 9,
    description: 'TREASURY', /// Hay que validarlo
  },
  INTEREST_RATE: {
    id: 10,
    description: 'INTEREST_RATE', /// Hay que validarlo
  },
  ASIA_INDEX: {
    id: 11,
    description: 'ASIA_INDEX',
  },
  EUR_INDEX: {
    id: 12,
    description: 'EUR_INDEX',
  },
  AME_INDEX: {
    id: 13,
    description: 'AME_INDEX',
  },
  AFRICA_INDEX: {
    id: 14,
    description: 'AFRICA_INDEX', /// Hay que validarlo
  },
  GBL_INDEX: {
    id: 15,
    description: 'GBL_INDEX',
  },
  CURRENCY: {
    id: 16,
    description: 'CURRENCY',
  },
  INTERNET_CURRENCY: {
    id: 18,
    description: 'INTERNET_CURRENCY',
  },
};

export const CURRENCY_TYPE_ID = {
  USD: 2,
  MXN: 1,
};
